import React from 'react';
import { usePlaidLink } from 'react-plaid-link';

import { AnalyticsEventNames } from '~/constants/AnalyticsEventMap';
import { useTracking } from '~/hooks/tracking/useTracking';
import { IconBank } from '~/vinovest-design-system/components/Icons';

import { ConnectSourceOption } from './ConnectSourceOption';
import { useConnectBank } from './useConnectBank';

export interface BankAccountProps {
    token: string;
    setLoading: (state: boolean) => void;
    setError: (error: string) => void;
    setIsPlaidComplete: (completed: boolean) => void;
    onPaymentLinked: () => void;
}

/** Button to open the Plaid modal to connect a bank. */
/** Upgraded to 3.5.1 01-22-24 */
export const ConnectBank = ({ token, setLoading, setError, onPaymentLinked, setIsPlaidComplete }: BankAccountProps) => {
    const { captureEvent } = useTracking();
    const { config } = useConnectBank({ token, setLoading, setError, onPaymentLinked, setIsPlaidComplete });
    const { open, ready } = usePlaidLink(config);

    return (
        <ConnectSourceOption
            title={'Bank Account'}
            subtitle={'2-3 business days'}
            icon={<IconBank className={'h-5 w-5 stroke-blue-300'} />}
            onClick={() => {
                setIsPlaidComplete(false);
                open();
                captureEvent(AnalyticsEventNames.SelectPaymentMethod, { paymentMethod: 'bank_account', type: 'ach' });
            }}
            disabled={!ready}
        />
    );
};
